import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Preview } from './Preview'
import { Youtube } from '../pages/Youtube'
import YouTube from 'react-youtube'
import { isMobile } from 'react-device-detect'
import { GuideToUse } from './GuideToUse'
import { useTranslation } from '../hooks/useTranslation'

export const FAQ = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [isPreview, setPreview] = useState<boolean>(true)
  return (
    <div className="flex flex-col w-[343px] md:w-[816px] gap-[16px]  mb-[80px] md:mb-10 items-center md:items-start">
      {pathname === '/' && (
        <div className="flex flex-col gap-[16px] w-full">
          <p className="md:text-[40px] text-[34px] font-bold">
            <span className="text-main">{t('faq.title')}</span>
          </p>
        </div>
      )}
      <div className="flex flex-col w-full text-[#2E343D] gap-2">
        <div className="flex md:flex-row flex-col md:justify-between md:items-center">
          <p className="font-bold text-[24px]">
            {t('faq.videoSection.title')}
          </p>
          <a
            className="text-[18px] text-[#5E6068]"
            href="https://angelleague.notion.site/AI-kr-15bba20e97f3809b8d33d7b08aaacd3f?pvs=4"
            target="_blank"
            rel="noreferrer"
          >{t('faq.videoSection.watchVideo')} &gt;</a>
        </div>
        {isMobile ? (
          <>
            <div className="flex gap-2 flex-col">
              <YouTube
                videoId={'UUu4FD1Fti0'}
                opts={{ width: '343', height: '180' }}
              />

              <YouTube
                videoId={'eBx_lXdxxHw'}
                opts={{ width: '343', height: '180' }}
              />
              <div>
                <YouTube
                  videoId={'K88BCTLTNIU'}
                  opts={{ width: '343', height: '180' }}
                />
              </div>
              <YouTube
                videoId={'kjOXDIvw9rs'}
                opts={{ width: '343', height: '180' }}
              />
            </div>
          </>
        ) : (
          <>
            <div className="flex gap-2">
              <YouTube
                videoId={'UUu4FD1Fti0'}
                opts={{ width: '198', height: '112' }}
              />
              <YouTube
                videoId={'eBx_lXdxxHw'}
                opts={{ width: '198', height: '112' }}
              />
              <div>
                <YouTube
                  videoId={'K88BCTLTNIU'}
                  opts={{ width: '198', height: '112' }}
                />
              </div>
              <YouTube
                videoId={'kjOXDIvw9rs'}
                opts={{ width: '198', height: '112' }}
              />
            </div>
          </>
        )}
      </div>
      <div className="flex flex-col p-[32px] w-full bg-[#F6F8FB] text-[#2E343D] gap-[32px] rounded-[40px]">
        <div className="flex flex-col gap-[8px]">
          <p className="font-bold text-[24px]">{t('faq.questions.q1.question')}</p>
          <p className="text-[#5E6068] text-[18px] ">
            {t('faq.questions.q1.answer')}
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="font-bold text-[24px]">
            {t('faq.questions.q2.question')}
          </p>
          <p className="text-[#5E6068] text-[18px]">
            {t('faq.questions.q2.answer')}
          </p>
        </div>

        <div className="flex flex-col">
          <p className="font-bold text-[24px] mt-2">
            {t('faq.questions.q3.question')}
          </p>
          <p className="text-[#5E6068] text-[18px] ">
            {t('faq.questions.q3.answer')}
          </p>
        </div>

        <div className="flex flex-col">
          <p className="font-bold text-[24px] mt-2">
            {t('faq.questions.q4.question')}
          </p>
          <p className="text-[#5E6068] text-[18px] ">
            {t('faq.questions.q4.answer')}
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="font-bold text-[24px]">
            {t('faq.questions.q5.question')}
          </p>
          <p className="text-[18px]">
            {t('faq.questions.q5.answer')}
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="font-bold text-[24px]">
            {t('faq.questions.q6.question')}
          </p>
          <p className="text-[18px]">
            {t('faq.questions.q6.answer')}
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="font-bold text-[24px]">
            {t('faq.questions.q7.question')}
          </p>
          <p className="text-[18px]">
            {t('faq.questions.q7.answer')}
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="font-bold text-[24px]">
            {t('faq.questions.q8.question')}
          </p>
          <p className="text-[18px]">
            {t('faq.questions.q8.answer')}
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="font-bold text-[24px]">
            {t('faq.questions.q9.question')}
          </p>
          <p className="text-[18px]">
            {t('faq.questions.q9.answer')}
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="font-bold text-[24px]">
            {t('faq.questions.q10.question')}
          </p>
          <p className="text-[18px]">
            {t('faq.questions.q10.answer')}
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="font-bold text-[24px]">
            {t('faq.questions.q11.question')}
          </p>
          <p className="text-[18px]">
            {t('faq.questions.q11.answer')}
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="font-bold text-[24px]">
            {t('faq.questions.q12.question')}
          </p>
          <p className="text-[18px]">
            {t('faq.questions.q12.answer')}
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="font-bold text-[24px]">
            {t('faq.questions.q13.question')}
          </p>
          <p className="text-[18px]">
            {t('faq.questions.q13.answer')}
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="font-bold text-[24px]">
            {t('faq.questions.q14.question')}
          </p>
          <p className="text-[18px]">
            {t('faq.questions.q14.answer')}
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="font-bold text-[24px]">
            {t('faq.questions.q15.question')}
          </p>
          <p className="text-[18px]">
            {t('faq.questions.q15.answer')}
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="font-bold text-[24px]">
            {t('faq.questions.q16.question')}
          </p>
          <p className="text-[18px]">
            {t('faq.questions.q16.answer')}
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="font-bold text-[24px]">
            {t('faq.questions.q17.question')}
          </p>
          <p className="text-[18px]">
            {t('faq.questions.q17.answer')}
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="font-bold text-[24px]">
            {t('faq.questions.q18.question')}
          </p>
          <p className="text-[18px]">
            {t('faq.questions.q18.answer')}
          </p>
        </div>
        <div className="flex flex-col gap-[8px]">
          <p className="font-bold text-[24px]">
            {t('faq.questions.q19.question')}
          </p>
          <p className="text-[18px]">
            {t('faq.questions.q19.answer')}
          </p>
        </div>
      </div>
      <GuideToUse />
    </div>
  )
}